module.exports = __webpack_public_path__ + "static/img/company9.95152ede.png";